
export const streamReply = (url, data, token, opts) => {
  const { onContent, onDone, onError } = opts
  const xhr = new XMLHttpRequest();
  xhr.open('POST', url)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.setRequestHeader('Authorization', 'Bearer ' + token)
  for (const [name, value] of Object.entries(opts.headers || {})) xhr.setRequestHeader(name, value)
  let finished = false
  const fail = () => {
    if (finished) return
    finished = true
    onError(new Error(`Error processing stream completion (XHR readyState ${xhr.readyState}, status ${xhr.status}).`), xhr.status, xhr)
  }
  xhr.onprogress = () => {
    if (!finished && xhr.status >= 200 && xhr.status < 300) onContent(xhr.responseText)
  }
  xhr.onreadystatechange = () => {
    if (!finished && xhr.readyState === XMLHttpRequest.DONE) {
      const status = xhr.status;
      if (status >= 200 && status < 300) {
        finished = true
        onDone(xhr);
      }
      else fail()
    }
  }
  xhr.onerror = fail
  xhr.onabort = fail
  xhr.ontimeout = fail
  xhr.send(JSON.stringify(data))
  return xhr
}

